import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header/Header";
import ProgramsList from "./components/ProgramsList/ProgramsList";

import Search from "./components/Search/Search";
import "./styles/styles.scss";
import Build from "./screens/Build";
import Participant from "./screens/Participant";
import ParticipantsList from "./components/ParticipantsList";


function App() {
  return (
    <Router>
      <Switch>
        {/*PROGRAM LIST*/}
        <Route exact path="/">
          <Header title="Program" />
          <Search />
          <ProgramsList />
        </Route>

        {/*PARTICIPANT LIST*/}
        <Route exact path="/participants">
          <Participant />
        </Route>

        {/*BUILD PROGRAM*/}
        <Route path="/build/:id?" component={Build} />
      </Switch>
    </Router>
  );
}

export default App;
